const mainUrl = new URL(import.meta.env.VITE_BASE_URL);
if (
  import.meta.env.VITE_ENFORCE_CANONICAL_HOST === "true" &&
  window?.location?.host &&
  window.location.host !== mainUrl.host
) {
  window.location.replace(mainUrl.href);
}

import { registerChartJS } from "@/plugins/chart.js";
import { i18n } from "@/plugins/i18n.js";
import { vuetify } from "@/plugins/vuetify.js";
import { createPinia } from "pinia";
import { createApp } from "vue";
// console.log('vuetify', vuetify);
import App from "@/app.vue";
import router, {
  clearGuard,
  guardAuthData,
  guardAuthRedirects,
  guardFilters,
  guardRowData,
} from "@/router";
import { initialize } from "@/services/firebase";
import {
  useAuthenticationStore,
  useAuthorizationStore,
  useDatabaseStore,
  useMainStore,
} from "@/stores";

initialize();
const app = createApp(App)
  .use(i18n)
  .use(vuetify)
  .use(createPinia())
  .use(router)
  .mount("#app");

registerChartJS(vuetify);

window.addEventListener("online", () => {
  useMainStore().offLine = false;
});
window.addEventListener("offline", () => {
  useMainStore().offLine = true;
});

for (const guard of [
  guardAuthData({
    useMainStore,
    useAuthenticationStore,
    useAuthorizationStore,
    useDatabaseStore,
  }),
  guardAuthRedirects,
]) {
  router.beforeEach(guard);
}
router.afterEach(guardFilters);
router.afterEach(guardRowData);
router.afterEach(clearGuard);

export default app;
